export default __webpack_public_path__ + "static/media/success.8c269261.png";